<div class="side-popup" *ngIf="showSidePopup">
    <div class="side-popup-content">
        <div class="side-popup-header">
            <h2 class="d-flex align-items-center m-0">
                <i class="ri-arrow-left-double-line me-2" (click)="onCloseSidePopup()" style="cursor: pointer;"
                    title="Back"></i>
                {{ isSubItem ? 'Subtask' : 'Task' }}
            </h2>
            <button class="close-button" (click)="onCloseSidePopup()">
                <i class="bx bx-x"></i>
            </button>
        </div>

        <!-- Form Body -->
        <form *ngIf="taskForm" [formGroup]="taskForm" class="side-popup-body"
            [ngClass]="{ 'disabled-dropdown': privilege === 'VIEW' }">
            <div class="form-field">
                <i class="bx bx-text field-icon"></i>
                <span class="field-label">Title</span>
                <div class="field-content">
                    <textarea #titleTextArea type="text" cols="1" rows="1" class="field-content textarea-input"
                        formControlName="title" placeholder="Enter task title" (blur)="triggerUpsert()"
                        (input)="resizeTextArea(titleTextArea)"></textarea>
                </div>
            </div>
            <div class="form-field">
                <i class="bx bx-time-five field-icon"></i>
                <span class="field-label">Status</span>
                <div class="field-content">
                    <div class="dropdown-container">
                        <div class="status-badge" [ngClass]="{
                            'not-started': taskForm.get('status')?.value === 'NOT_STARTED',
                            'in-progress': taskForm.get('status')?.value === 'IN_PROGRESS',
                            'completed': taskForm.get('status')?.value === 'COMPLETED',
                            'on-hold': taskForm.get('status')?.value === 'HOLD',
                            'reassigned': taskForm.get('status')?.value === 'REASSIGNED'
                          }" (click)="onToggleStatusDropdown(); $event.stopPropagation()">
                            <i [class]="
                                taskForm.get('status')?.value === 'NOT_STARTED' ? 'bx bx-pause-circle' :
                                taskForm.get('status')?.value === 'IN_PROGRESS' ? 'bx bx-time' :
                                taskForm.get('status')?.value === 'COMPLETED' ? 'bx bx-check-circle' :
                                taskForm.get('status')?.value === 'HOLD' ? 'bx bx-stop-circle' :
                                taskForm.get('status')?.value === 'REASSIGNED' ? 'bx bx-refresh' : ''
                            "></i>
                            {{ getTaskStatus(taskForm.get('status')?.value) }}
                            <i class="bx bx-chevron-down"></i>
                        </div>
                        <div class="dropdown-menu" [ngClass]="{'show': taskForm.get('showStatusDropdown')?.value}"
                            (click)="$event.stopPropagation()" (document:click)="onDocumentClick($event, 'status')">
                            <div class="dropdown-item" *ngFor="let status of statuses; let s=index"
                                (click)="status !== 'HOLD' || privilege === 'DELETE' ? setStatus(status) : null"
                                [ngClass]="{'active': s === searchIndex, 'disabled': status === 'HOLD' && privilege !== 'DELETE'}"
                                [attr.aria-disabled]="status === 'HOLD' && privilege !== 'DELETE' ? true : null">
                                <span class="status-badge" [ngClass]="{
      'not-started': status === 'NOT_STARTED',
      'in-progress': status === 'IN_PROGRESS',
      'completed': status === 'COMPLETED',
      'on-hold': status === 'HOLD',
      'reassigned': status === 'REASSIGNED'
    }">
                                    <i [class]="
        status === 'NOT_STARTED' ? 'bx bx-pause-circle' :
        status === 'IN_PROGRESS' ? 'bx bx-time' :
        status === 'COMPLETED' ? 'bx bx-check-circle' :
        status === 'HOLD' ? 'bx bx-stop-circle' :
        status === 'REASSIGNED' ? 'bx bx-refresh' : ''
    "></i>
                                    {{ getTaskStatus(status) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-field">
                <i class="bx bx-user field-icon"></i>
                <span class="field-label">Assigned To</span>
                <div class="field-content">
                    <div class="dropdown-container">
                        <div class="select-trigger" (click)="onToggleAssigneeDropdown(); $event.stopPropagation()">
                            <span *ngIf="taskForm.get('assignedToName')?.value" class="selected-assignee">
                                <ng-container *ngIf="taskForm.get('assignedToAvatar')?.value && 
                      (taskForm.get('assignedToAvatar')?.value.startsWith('data:image/') || 
                       taskForm.get('assignedToAvatar')?.value.startsWith('http')); 
               else showInitialSelected">
                                    <img class="assignee-avatar" [src]="taskForm.get('assignedToAvatar')?.value"
                                        alt="avatar" />
                                </ng-container>
                                <ng-template #showInitialSelected>
                                    <span class="assignee-avatar capitalize">
                                        {{ taskForm.get('assignedToName')?.value.charAt(0) }}
                                    </span>
                                </ng-template>
                                {{ taskForm.get('assignedToName')?.value }}
                            </span>
                            <span *ngIf="!taskForm.get('assignedToName')?.value" class="select-placeholder">
                                Choose assignee
                            </span>
                            <i class="bx bx-chevron-down"></i>
                        </div>
                        <div class="dropdown-menu" [ngClass]="{'show': taskForm.get('showAssigneeDropdown')?.value}"
                            (click)="$event.stopPropagation()" (document:click)="onDocumentClick($event, 'assignee')">
                            <div class="dropdown-search">
                                <input type="text" placeholder="Type to search..." [(ngModel)]="searchKeyword"
                                    [ngModelOptions]="{standalone: true}"
                                    (keydown)="handleKeyDown($event, 'assignee')" />
                            </div>
                            <div class="dropdown-list">
                                <div *ngIf="employees.length && 
                      (employees | search: 'employeeName': searchKeyword).length; else noEmployeesFound">
                                    <div *ngFor="let employee of employees | search: 'employeeName':searchKeyword; let a = index"
                                        class="dropdown-item" [ngClass]="{'active': a === searchIndex}"
                                        (click)="setAssignee(employee)">
                                        <ng-container *ngIf="employee.avatar && 
                                  (employee.avatar.startsWith('data:image/') || 
                                   employee.avatar.startsWith('http')); 
                           else showInitialDropdown">
                                            <img class="assignee-avatar" [src]="employee.avatar" alt="avatar" />
                                        </ng-container>
                                        <ng-template #showInitialDropdown>
                                            <span class="assignee-avatar capitalize">
                                                {{ employee.employeeName.charAt(0) }}
                                            </span>
                                        </ng-template>
                                        {{ employee.employeeName }}
                                    </div>
                                </div>
                                <ng-template #noEmployeesFound>
                                    <div class="no-results">No matches found</div>
                                </ng-template>
                            </div>
                            <div class="dropdown-footer" (click)="setAssignee(null)">
                                <i class="bx bx-x"></i> Clear
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="form-field">
                <i class="bx bx-user field-icon"></i>
                <span class="field-label">Assigned To</span>
                <div class="field-content">
                    <div class="dropdown-container">
                        <div class="select-trigger" (click)="onToggleAssigneeDropdown(); $event.stopPropagation()">
                            <span *ngIf="taskForm.get('assignedToName')?.value" class="selected-assignee">
                                <span class="assignee-avatar">{{ taskForm.get('assignedToName')?.value.charAt(0)
                                    }}</span>
                                {{ taskForm.get('assignedToName')?.value }}
                            </span>
                            <span *ngIf="!taskForm.get('assignedToName')?.value" class="select-placeholder">Choose
                                assignee</span>
                            <i class="bx bx-chevron-down"></i>
                        </div>
                        <div class="dropdown-menu" [ngClass]="{'show': taskForm.get('showAssigneeDropdown')?.value}"  (click)="$event.stopPropagation()" (document:click)="onDocumentClick($event, 'assignee')">
                            <div class="dropdown-search">
                                <input type="text" placeholder="Type to search..." [(ngModel)]="searchKeyword"
                                    [ngModelOptions]="{standalone: true}"
                                    (keydown)="handleKeyDown($event, 'assignee')" />
                            </div>
                            <div class="dropdown-list">
                                <div
                                    *ngIf="employees.length && (employees | search: 'employeeName': searchKeyword).length; else noEmployeesFound">
                                    <div *ngFor="let employee of employees | search: 'employeeName':searchKeyword; let a=index"
                                        class="dropdown-item" [ngClass]="{'active': a === searchIndex}"
                                        (click)="setAssignee(employee)">
                                        <span class="assignee-avatar">{{ employee.employeeName.charAt(0) }}</span>
                                        {{ employee.employeeName }}
                                    </div>
                                </div>
                                <ng-template #noEmployeesFound>
                                    <div class="no-results">No matches found</div>
                                </ng-template>
                            </div>
                            <div class="dropdown-footer" (click)="setAssignee(null)">
                                <i class="bx bx-x"></i> Clear
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="form-field">
                <i class="bx bx-flag field-icon"></i>
                <span class="field-label">Priority</span>
                <div class="field-content">
                    <div class="dropdown-container">
                        <div class="priority-badge" [ngClass]="{
                            'low': taskForm.get('priority')?.value === 'LOW',
                            'medium': taskForm.get('priority')?.value === 'MID',
                            'high': taskForm.get('priority')?.value === 'HIGH'
                          }" (click)="onTogglePriorityDropdown(); $event.stopPropagation()">
                            <i class="bx bxs-flag-alt"></i>
                            {{ taskForm.get('priority')?.value || 'Select Priority' }}
                            <i class="bx bx-chevron-down"></i>
                        </div>
                        <div class="dropdown-menu" [ngClass]="{'show': taskForm.get('showPriorityDropdown')?.value}"
                            (click)="$event.stopPropagation()" (document:click)="onDocumentClick($event, 'priority')">
                            <div class="dropdown-item" *ngFor="let priority of priorities; let p=index"
                                (click)="setPriority(priority)" [ngClass]="{'active': p === searchIndex}">
                                <span class="priority-badge" [ngClass]="{
                                    'low': priority === 'LOW',
                                    'medium': priority === 'MID',
                                    'high': priority === 'HIGH'
                                  }">
                                    <i class="bx bxs-flag-alt"></i>
                                    {{ priority }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-field">
                <i class="bx bx-calendar field-icon"></i>
                <span class="field-label">Milestone</span>
                <div class="field-content">
                    <div class="dropdown-container">
                        <div class="select-trigger" (click)="onToggleMilestoneDropdown(); $event.stopPropagation()">
                            <span *ngIf="taskForm.get('milestoneName')?.value" class="selected-assignee">
                                {{ taskForm.get('milestoneName')?.value }}
                            </span>
                            <span *ngIf="!taskForm.get('milestoneName')?.value" class="select-placeholder">Choose
                                milestone</span>
                            <i class="bx bx-chevron-down"></i>
                        </div>
                        <div class="dropdown-menu" [ngClass]="{'show': taskForm.get('showMilestoneDropdown')?.value}"
                            (click)="$event.stopPropagation()" (document:click)="onDocumentClick($event, 'milestone')">
                            <div class="dropdown-search">
                                <input type="text" placeholder="Search milestone..." [(ngModel)]="searchKeyword"
                                    [ngModelOptions]="{standalone: true}"
                                    (keydown)="handleKeyDown($event, 'milestone')" />
                            </div>
                            <div class="dropdown-list">
                                <div
                                    *ngIf="milestones.length && (milestones | search: 'title': searchKeyword).length; else noMilestonesFound">
                                    <div *ngFor="let milestone of milestones | search: 'title':searchKeyword; let m=index"
                                        class="dropdown-item" [ngClass]="{'active': m === searchIndex}"
                                        (click)="setMilestone(milestone)">
                                        <span class="assignee-avatar">{{ milestone.title.charAt(0) }}</span>
                                        {{ milestone.title }}
                                    </div>
                                </div>
                                <ng-template #noMilestonesFound>
                                    <div class="no-results">No matches found</div>
                                </ng-template>
                            </div>
                            <div class="dropdown-footer" (click)="setMilestone(null)">
                                <i class="bx bx-x"></i> Clear
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-field">
                <i class="bx bx-calendar field-icon"></i>
                <span class="field-label">Due Date</span>
                <div class="field-content">
                    <!-- When input is visible -->
                    <input #dueDateInput type="date" class="field-input" formControlName="deadLine"
                        (focus)="toggleDueDate()" (change)="triggerUpsert()" />
                </div>
            </div>
            <div class="form-field">
                <i class="bx bx-hourglass field-icon"></i>
                <span class="field-label">Estimated Hours</span>
                <div class="field-content">
                    <input type="number" class="field-input" formControlName="estimatedHour" placeholder="Enter hours"
                        min="0" (blur)="triggerUpsert()" />
                </div>
            </div>
            <div class="form-field">
                <i class="bx bx-calendar field-icon"></i>
                <span class="field-label">Completed Hour</span>
                <div class="field-content" tabindex="0">
                    <input class="field-input" style="border: none;" readonly formControlName="completedHour" />
                </div>
            </div>
            <div class="form-field">
                <i class="bx bx-calendar field-icon"></i>
                <span class="field-label">Start Date</span>
                <div class="field-content">
                    <span class="field-value" [ngClass]="{'empty': !taskForm.get('startDate')?.value}">
                        {{ taskForm.get('startDate')?.value ? (taskForm.get('startDate')?.value | date: 'dd-MM-yyyy') :
                        '' }}
                    </span>
                </div>
            </div>
            <div class="form-field">
                <i class="bx bx-calendar field-icon"></i>
                <span class="field-label">Completed Date</span>
                <div class="field-content">
                    <span class="field-value" [ngClass]="{'empty': !taskForm.get('endDate')?.value}">
                        {{ taskForm.get('endDate')?.value ? (taskForm.get('endDate')?.value | date: 'dd-MM-yyyy') :
                        '' }}
                    </span>
                </div>
            </div>
            <div class="form-field">
                <i class="bx bx-paperclip field-icon"></i>
                <span class="field-label">Attachments</span>

                <div class="field-content">
                    <div class="image-grid" formArrayName="taskAttachments">
                        <div *ngFor="let attachment of taskAttachments.controls; let j = index" class="attachment-item"
                            [formGroupName]="j">
                            <div class="image-wrapper" *ngIf="attachment.get('fileUrl')?.value">
                                <a [href]="attachment.get('fileUrl')?.value" download target="_blank">
                                    <img [src]="getFilePreviewIcon(attachment.get('fileUrl')?.value)"
                                        alt="Uploaded Image" class="uploaded-image" />
                                </a>
                            </div>
                        </div>
                        <div class="icon-wrapper" (click)="openFilePicker()">
                            <i class="bx bx-paperclip attachment-add-icon" ngbTooltip="Add attachment"></i>
                        </div>
                    </div>
                    <input type="file" #fileInput
                        accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.mp4,.avi,.mkv,.mov"
                        style="display: none" (change)="onFileSelected($event)" />
                </div>
            </div>

            <div class="form-field textarea-field">
                <i class="bx bx-note field-icon"></i>
                <span class="field-label">Priority Notes</span>
                <div class="field-content">
                    <textarea #priorityNotesTextArea class="field-content textarea-input" cols="1" rows="1"
                        formControlName="desc" placeholder="Enter priority notes..."
                        (input)="resizeTextArea(priorityNotesTextArea)" (blur)="triggerUpsert()"></textarea>
                </div>
            </div>
        </form>
    </div>
</div>